import React from 'react'
import { Container, Content, TextHolder, Button } from './style.css'

const Hero = () => {
  return (
    <Container>
      <Content>
        <TextHolder>
          <h2 className="leading-none tracking-tight text-3xl ">
            ¿Tiene un momento
            <br /> para hablarle <br />
            de la suscripción digital?
          </h2>
          <p>
            Nuestro equipo trabaja las 24 horas para informar, analizar, servir
            y entretener. Conoce los beneficios de ser parte de nuestra
            comunidad y elige un plan para ti.
          </p>
          {/* {urlValueProp && ( */}
          <Button
            href="https://suscripciondigital.latercera.com/"
            target="_blank"
            rel="noopener noreferrer">
            Suscríbete
          </Button>
        </TextHolder>
      </Content>
    </Container>
  )
}

export default Hero
